<template>
  <div class="py-3 px-2" style="box-shadow: rgba(17, 12, 46, 0.15) 0px 48px 100px 0px;">
    <div class="px-0">
      <div class="">
        <ValidationObserver ref="obs">
          <ValidationProvider
            name="Hoạt động"
            rules="required-input: ghi chú "
            v-slot="{ errors }"
          >
            <div class="input-wrapper">
              <el-input
                class="custom-input"
                ref="noteInput"
                type="textarea"
                :autosize="{ minRows: 2, maxRows: 5 }"
                placeholder="Thêm ghi chú"
                v-model="formData.note"
                show-word-limit
                @input="onInput"
                @keydown.native="onKeyDown"
              ></el-input>
              <!-- <div class="d-flex flex-row-reverse" style="font-size: 12px; color: gray">
                {{ formData.note.length }} / 256
              </div> -->
              <div class="d-flex align-items-center mt-1 gap-2">
                <el-button size="mini" @click="openMentionByButton">@</el-button>

                <div v-if="showMention" ref="mentionDropdown" class="mention-dropdown" :style="{ top: dropdownTop + 'px', left: dropdownLeft + 'px' }">
                  <div
                    v-for="emp in filteredEmployees"
                    :key="emp.id"
                    class="mention-item"
                    @click="selectMention(emp)"
                  >
                    {{ emp.username }}
                  </div>
                </div>
              </div>
            </div>
            <div  style="min-height: 1.3rem;" class="mt-1 ms-1">
              <InputError v-if="errors[0]" :message="errors[0]" />
            </div>
          </ValidationProvider>
        </ValidationObserver>
      </div>

      <div class="mt-2">
        <div class="pb-1">
          <p class="mb-2">
            Tệp đính kèm <span>({{ files.length }})</span>:
          </p>
          <div class="d-flex align-items-center justify-content-between">
            <div class="d-flex" style="position: relative">
              <div
                class="d-flex justify-content-between align-items-center gap-2 me-2"
                v-for="file in files.slice(0, 2)"
                :key="file.name"
              >
                <div class="upload-input">
                  <div class="d-flex align-items-center">
                    <div class="material-icons" style="font-size: 16px">
                      attach_file
                    </div>
                    <span class="text-ellipsis">{{ file.name }}</span>
                    <div @click="removeFile(file)" style="cursor: pointer">
                      <IconFont name="icon-close" color="#327AE7" />
                    </div>
                  </div>
                </div>
              </div>

              <div
                v-if="files.length > 2"
                class="upload-input more-files me-2"
                @click="openFile"
              >
                +{{ files.length - 2 }}
              </div>
              <div class="open-file" v-if="isOpen">
                <div
                  class="d-flex justify-content-between align-items-center gap-2 me-2 mb-2"
                  v-for="file in files.slice(2, files.length)"
                  :key="file.name"
                >
                  <div class="upload-input">
                    <div class="d-flex align-items-center">
                      <div class="material-icons" style="font-size: 16px">
                        attach_file
                      </div>
                      <span class="text-ellipsis">{{ file.name }}</span>
                      <div @click.stop  ="removeFile(file)" class="close-file" style="cursor: pointer">
                        <IconFont name="icon-close" color="#327AE7" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="d-flex w-100 pe-2" @click="$refs.files.click()">
              <div
                class="upload-input d-flex align-items-center justify-content-between"
              >
                Tải tệp đính kèm
                <IconFont :color="'#327AE7'" :name="'icon-import'" />
              </div>
            </div>
            <input
              style="display: none; width: 0; height: 0"
              ref="files"
              type="file"
              multiple
              @change="fileSelected"
            />
            <el-button
              size="small"
              type="primary"
              @click="createHistory"
              :loading="creating"
              :disabled="!formData.note.trim() || creating"
              >Tạo ghi chú</el-button
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { HTTP } from "@/lib/http-common";
import IconFont from "../common/IconFont.vue";
export default {
  props: ['selectedContact', 'steps', 'processId'],
  components: {
    IconFont,
  },
  data() {
    const now = new Date();
    const tenMinutesLater = new Date(now.getTime() + 10 * 60 * 1000);
    return {
      employeeOptions: [],
      formData: {
        title: "",
        startTime: now,
        createTime: now,
        endTime: tenMinutesLater,
        note: "",
        time: "",
        selectedEmployee: [],
        fileIds: "",
        processId: "",
        workflowId: "",
      },
      options: [
        { value: "Phút", label: "Phút" },
        { value: "Giờ", label: "Giờ" },
      ],
      pickerOptions: {
        disabledDate(time) {
          const yesterday = new Date();
          yesterday.setDate(yesterday.getDate() - 1);
          return time.getTime() < yesterday.getTime();
        },
      },
      startTimeOptions: {},
      endTimeOptions: {},
      value: "",
      files: [],
      creating: false,
      isOpen: false,
      filteredEmployees: [],  // danh sách hiển thị dropdown
      mentions: [],           // list mention đã chọn
      showMention: false,
      mentionIndex: -1,       // vị trí bắt đầu '@'
      cursorPos: 0,
      dropdownTop: 0,
      dropdownLeft: 0,
      isOpeningMention: false,
    };
  },
  methods: {
    onKeyDown(e) {
      const textarea = e.target;

      if (e.key === 'Enter' && e.shiftKey) {
        return;
      }

      if (e.key === 'Enter') {
        e.preventDefault();
        this.createHistory();
        return;
      }

      if (e.code === 'Digit2' && e.shiftKey) {
        e.preventDefault();

        this.cursorPos = textarea.selectionStart;
        this.mentionIndex = this.cursorPos;

        this.formData.note =
          this.formData.note.slice(0, this.cursorPos) +
          '@' +
          this.formData.note.slice(this.cursorPos);

        this.cursorPos += 1;

        this.$nextTick(() => {
          textarea.setSelectionRange(this.cursorPos, this.cursorPos);
          this.openMention(textarea);
        });
      }
    },
    onInput() {
      const textarea = this.$refs.noteInput?.$el?.querySelector('textarea')

      if (textarea) {
        this.cursorPos = textarea.selectionStart
      }

      this.syncMentionsWithText()

      if (
        this.mentionIndex !== -1 &&
        this.formData.note[this.mentionIndex] !== '@'
      ) {
        this.resetMention()
        return;
      }
      if (this.showMention) {
        this.filterEmployees()
      }
    },
    openMentionByButton() {
      this.isOpeningMention = true
      this.$nextTick(() => {
        const input = this.$refs.noteInput
        if (!input || !input.$el) return

        const textarea = input.$el.querySelector('textarea')
        if (!textarea) return

        textarea.focus()

        this.cursorPos = textarea.selectionStart
        this.mentionIndex = this.cursorPos

        this.formData.note =
          this.formData.note.slice(0, this.cursorPos) +
          '@' +
          this.formData.note.slice(this.cursorPos)

        this.cursorPos += 1

        this.$nextTick(() => {
          textarea.setSelectionRange(this.cursorPos, this.cursorPos)
          this.openMention(textarea)
          this.isOpeningMention = false
        })
      })
    },
    openMention(textarea) {
      this.showMention = true

      this.filterEmployees()
      if (textarea) {
        this.calculateDropdownPosition(textarea)
      }
    },
    selectMention(emp) {
      const nameText = `@${emp.username}`

      const before = this.formData.note.slice(0, this.mentionIndex)
      const after = this.formData.note.slice(this.cursorPos)

      this.formData.note = before + nameText + ' ' + after

      this.mentions.push({
        id: emp.id,
        name: emp.username,
        start: this.mentionIndex,
        length: nameText.length
      })

      this.resetMention()
    },
    resetMention() {
      this.showMention = false
      this.mentionIndex = -1
      // this.filteredEmployees = []
    },
    calculateDropdownPosition(textarea) {
      if (!textarea) return

      const wrapper = textarea.closest('.input-wrapper')
      if (!wrapper) return

      const textareaRect = textarea.getBoundingClientRect()
      const wrapperRect = wrapper.getBoundingClientRect()

      const lineHeight = 22

      const caretPos = textarea.selectionStart

      const textBeforeCursor = textarea.value.slice(0, caretPos)
    
      const lines = textBeforeCursor.replace(/\r\n/g, '\n').split('\n')
      const currentLine = lines.length - 1

      // 🔥 TÍNH TƯƠNG ĐỐI WRAPPER
      this.dropdownTop =
        textareaRect.top -
        wrapperRect.top +
        (currentLine + 1) * lineHeight

      this.dropdownLeft =
        textareaRect.left -
        wrapperRect.left +
        12
    },
    syncMentionsWithText() {
      const text = this.formData.note

      this.mentions = this.mentions.filter(m => {
        const mentionText = `@${m.name}`
        return text.substr(m.start, mentionText.length) === mentionText
      })
    },
    getMentionQuery() {
      if (this.mentionIndex === -1) return ''

      console.log(333);
      
      return this.formData.note
        .slice(this.mentionIndex + 1, this.cursorPos)
        .trim()
    },
    filterEmployees() {
      const query = this.getMentionQuery().toLowerCase()

      this.filteredEmployees = this.app.employeeList.filter(e => {
        if (!e.active) return false

        if (!query) return true

        return e.username.toLowerCase().includes(query)
      })
    },
    handleClickOutsideMention(e) {
      if (!this.showMention) return

      const dropdown = this.$refs.mentionDropdown
      const textarea =
        this.$refs.noteInput?.$el?.querySelector('textarea')

      if (!dropdown || !textarea) return

      // Click trong dropdown hoặc textarea → bỏ qua
      if (
        dropdown.contains(e.target) ||
        textarea.contains(e.target)
      ) {
        return
      }

      // Click ra ngoài
      this.resetMention()
    },
    handleClickOutside(event) {
      if (
        this.isOpen &&
        !this.$el.querySelector(".open-file")?.contains(event.target) &&
        !this.$el.querySelector(".more-files")?.contains(event.target)
      ) {
        this.isOpen = false;
      }
    },
    openFile() {
      this.isOpen = !this.isOpen;
    },
    removeFile(file) {
      const index = this.files.indexOf(file);
      if (index !== -1) {
        this.files.splice(index, 1);
        if(this.files.length == 2){
          this.isOpen = false
        }
      }
    },
    fileSelected(e) {
      if (!e.target.files || e.target.files.length === 0) {
        console.warn("Không có file nào được chọn.");
        return;
      }
      const MAX_SIZE = 200 * 1024 * 1024; // 200MB cho mỗi file và cho tổng file
      const selectedFiles = Array.from(e.target.files);

      let totalSize = this.files.reduce((sum, f) => sum + f.size, 0);

      selectedFiles.forEach((file) => {
        const isDuplicate = this.files.some(
          (existingFile) =>
            existingFile.name === file.name && existingFile.size === file.size
        );

        if (isDuplicate) {
          this.alert("error", `Tệp ${file.name} đã có. Không thể tải lên`);
          return;
        }
        if (file.size > MAX_SIZE) {
          this.alert("error", `Tệp ${file.name} vượt quá 200MB. Không thể tải lên`);
          return;
        }
        if (totalSize + file.size > MAX_SIZE) {
          this.alert(
            "error",
            `Tổng dung lượng tệp vượt quá 200MB. Không thể thêm ${file.name}`
          );
          return;
        }
        this.files.push(file);
        totalSize += file.size;
      });
      this.$refs.files.value = "";
    },
    // async getEmployee() {
    //   const res = await HTTP.get("/api/employee/get-all");
    //   this.employeeOptions = res.data;
    // },
    resetFormData() {
      const now = new Date();
      const tenMinutesLater = new Date(now.getTime() + 10 * 60 * 1000);

      this.formData = {
        title: "",
        createTime: now,
        startTime: now,
        endTime: tenMinutesLater,
        note: "",
        time: "",
        selectedEmployee: [],
        notification: false,
        fileIds: "",
        processId: "",
        workflowId: "",
      };
      this.files = [];
    },
    close() {
      this.resetFormData();
      this.$emit("close-dialog");
    },
    async createHistory() {
      if(this.formData.note.trim().length ==0) return;
      if (this.creating) return;
      this.creating = true;
      const uploaded = await this.uploadFiles(this.selectedContact.id);
      if (!uploaded) {
        // Upload thất bại: không gọi API tạo, giữ nguyên nội dung, mở lại nút.
        this.creating = false;
        return;
      }

      // const employeeIds = this.employeeOptions
      //   .filter((user) =>
      //     this.formData.selectedEmployee.includes(user.username)
      //   )
      //   .map((user) => user.id);
      // const filteredSteps = this.steps.filter(
      //   (step) => step.id === this.selectedContact.workflowId
      // );
      // this.formData.title = filteredSteps[0].title;
      const data = {
        // title: this.formData.title,
        // workflowId: this.selectedContact.workflowId,
        // createTime: new Date(this.formData.createTime).getTime(),
        // startTime: new Date(this.formData.startTime).getTime(),
        endTime: new Date(this.formData.endTime).getTime(),
        note: this.formData.note,
        // time: this.formData.time,
        // notification: this.formData.notification,
        // employeeIds: employeeIds,
        contactId: this.selectedContact.id,
        type: "create",
        fileIds: this.formData.fileIds,
        processId: this.processId,
        workflowId: this.selectedContact.processAndWorkflow?.find(
          (f) => f.processId === this.processId
        )?.workflowId,
        mention: JSON.stringify(this.mentions)
      };
      try {
        const response = await HTTP.post("/api/activity/create", data);
        if (response.status === "success") {
          this.$message.success("Thêm lịch sử hoạt động thành công!");
          this.resetFormData();
          this.$emit("created");
          this.$emit("update");
        }
      } catch (error) {
        console.error("Lỗi khi tạo lịch sử hoạt động:", error);
      } finally {
        this.creating = false;
      }
    },
    // Trả về true nếu tải lên toàn bộ file thành công, false nếu có file lỗi.
    async uploadFiles(contactId) {
      const uploadUrl = this.getUploadUrl(contactId);

      // Build lại fileIds từ đầu để retry không bị nhân đôi id.
      this.formData.fileIds = "";

      for (const file of this.files) {
        const formData = new FormData();
        formData.append("file", file);
        try {
          const res = await HTTP.post(uploadUrl, formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          });
          if (res.status === "success") {
            const newFileIds = res.data;

            if (this.formData.fileIds) {
              this.formData.fileIds += "," + newFileIds.join(",");
            } else {
              this.formData.fileIds = newFileIds.join(",");
            }
          } else {
            this.alert("error", "Tải lên tệp thất bại");
            return false;
          }
        } catch (error) {
          console.error("Error uploading file:", error);
          this.alert("error", "Tải lên thất bại");
          return false;
        }
      }
      return true;
    },
    getUploadUrl(contactId) {
      let HOST = "https://contact.salework.net";
      // let HOST = "http://localhost:9090";
      // if (Config.DEV) {
      //   HOST = "http://localhost:9090";
      // } else {
      //   HOST = "https://zalo.salework.net";
      // }
      return HOST + "/api/contact-file/upload?contactId=" + contactId;
    },
    updatePickerOptions() {
      this.startTimeOptions = this.getStartTimePickerOptions();
      this.endTimeOptions = this.getEndTimePickerOptions();
    },
    updateEndTimeOptions() {
      this.endTimeOptions = this.getEndTimePickerOptions();
    },
    getStartTimePickerOptions() {
      const now = new Date();
      const createTime = new Date(this.formData.createTime);

      if (createTime.toDateString() === now.toDateString()) {
        return {
          selectableRange: `${now.getHours()}:${now.getMinutes()}:${now.getSeconds()} - 23:59:59`,
        };
      }
      return {
        selectableRange: "00:00:00 - 23:59:59",
      };
    },
    getEndTimePickerOptions() {
      if (!this.formData.startTime)
        return { selectableRange: "00:00:00 - 23:59:59" };
      const startTime = new Date(this.formData.startTime);
      return {
        selectableRange: `${startTime.getHours()}:${startTime.getMinutes()}:${startTime.getSeconds()} - 23:59:59`,
      };
    },
  },
  watch: {
    // "formData.startTime"() {
    //   this.updateEndTimeOptions();
    // },
  },
  created() {
    // this.getEmployee();
  },
  mounted() {
    document.addEventListener("click", this.handleClickOutside);
    document.addEventListener('mousedown', this.handleClickOutsideMention)
    this.filteredEmployees = this.app.employeeList.filter(em => em.active);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.handleClickOutside);
    document.removeEventListener('mousedown', this.handleClickOutsideMention)
  },
};
</script>

<style scoped>
.el-input--small >>> .el-input__inner {
  padding-right: 0px !important;
}

.el-select >>> .el-tag.el-tag--info {
  max-width: 110px !important;
}

.upload >>> .el-upload {
  width: 100%;
  overflow: hidden;
}

.upload >>> .el-upload-dragger {
  height: 100%;
  width: 100%;
  border: 1px #ffffff solid;
  overflow: hidden;
}

.upload >>> .el-upload-dragger {
  height: 100%;
  width: 100%;
  border: 1px #ffffff solid;
}

.upload.no-click >>> .el-upload {
  cursor: no-drop !important;
}
.upload-input {
  max-height: 32px;
  width: 100%;
  padding: 5px 8px;
  cursor: pointer;
  border-radius: 4px;
  border: 1px dashed #85b1ff;
  background: #d4e4ff;
  color: #327ae7;
}

.upload-input >>> input {
  cursor: pointer;
  border-radius: 4px;
  border: 1px dashed #85b1ff;
  background: #d4e4ff;
  color: #327ae7;
}
.text-ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100px;
}
.input-wrapper {
  position: relative;
  width: 100%;
}

.char-counter {
  font-size: 12px;
  color: gray;
  pointer-events: none;
}

.open-file {
  height: 150px;
  overflow-y: scroll;
  position: absolute;
  top: 38px;
  right: 0;
  z-index: 999999;
  background: #fff;
  padding: 8px;
  border-radius: 4px;
  box-shadow: rgba(0, 0, 0, 0.25) 0px 54px 55px,
    rgba(0, 0, 0, 0.12) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px,
    rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px;
}

.custom-input >>> .el-input__inner {
  padding-right: 55px !important;
}
.mention-wrapper {
  position: relative;
}

.mention-dropdown {
  position: absolute;
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 6px;
  min-width: 200px;
  max-height: 220px;
  overflow-y: auto;
  z-index: 9999;
  box-shadow: 0 4px 12px rgba(0,0,0,.15);
}

.mention-item {
  padding: 8px 12px;
  cursor: pointer;
}

.mention-item:hover {
  background: #f2f4f7;
}
</style>
